import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth, rememberNext } from "@/lib/auth";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import DocumentChat from "@/pages/DocumentChat";
import CompareHub from "@/pages/CompareHub";
import ComparePage from "@/pages/ComparePage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import PayPalReturn from "@/pages/PayPalReturn";
import PublicVideo from "@/pages/PublicVideo";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import BotChat from "@/pages/BotChat";
import AuthCallback from "@/components/AuthCallback";
import { useLocation } from "react-router-dom";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm uppercase tracking-widest text-muted-foreground">Loading…</div>;
  if (!user) {
    rememberNext(location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }
  return children;
}

function AppRoutes() {
  const location = useLocation();
  // Returning from Google: exchange session_id before any protected route runs.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/compare" element={<CompareHub />} />
      <Route path="/compare/:slug" element={<ComparePage />} />
      <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
      <Route path="/payment/paypal" element={<Protected><PayPalReturn /></Protected>} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/v/:token" element={<PublicVideo />} />
      <Route path="/b/:token" element={<Protected><BotChat /></Protected>} />
      <Route path="/app" element={<Protected><Dashboard /></Protected>} />
      <Route path="/app/chat/:docIds" element={<Protected><DocumentChat /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" />
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
